<template>
  <BaseModal ref="modal">
    <UiModalDialog
      dialog-width="15rem"
    >
      <template #header>
        <BaseIcon name="mdi/plus" />
        {{ lss('値の追加', 'Add value') }}
      </template>
      <div class="jps-modal-content">
        <form @submit.prevent="addValue()">
          <div v-if="isLangString">
            <LangStringEditor :rule="ruleField" :value="modalValue" />
          </div>
          <input
            v-else-if="isText"
            type="text"
            class="jps-input"
            v-model="modalValue"
          />
          <input
            v-else-if="isNumber"
            type="number"
            class="input"
            v-model="modalValue"
            :min="ruleField.numMin"
            :max="ruleField.numMax"
          />
          <div v-else-if="isCode && codeKeys" class="jps-select">
            <select v-model="modalValue">
              <option
                v-for="c in codeKeys.filter(k => !selected.includes(k))"
                :value="c"
                :key="c"
              >
                {{ lc(code, c) }}
              </option>
            </select>
          </div>
          <div v-else-if="isEnum" class="jps-select">
            <select v-model="modalValue">
              <option
                v-for="e in enumKeys.filter(k => !selected.includes(k))"
                :value="e"
                :key="e"
              >
                {{ e }}
              </option>
            </select>
          </div>
        </form>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="addValue()">{{ ls(dapLangGlobal.add) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import type { BaseModal } from '#components'
import { dapLangGlobal } from '#imports'

const { ls, lss, lc } = useI18n()

const modalValue: Ref<any> = ref(null)

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  modalValue.value = null
  if (isLangString.value) {
    modalValue.value = { ja: '', en: '' }
  }
  return await modal.value.openAwait<any>()
}
defineExpose({ openAwait })

interface Props {
  selected: any[],
  rule: ValidationRule,
  ruleField: ValidationRuleField,
}
const props = withDefaults(defineProps<Props>(), {})
const {
  isLangString,
  isText,
  isNumber,
  isCode,
  code,
  codeKeys,
  isEnum,
  enumKeys,
} = useValidation(props.rule, props.ruleField)

const addValue = () => {
  if (modalValue.value) {
    modal.value.resolve(modalValue.value)
  }
}
</script>

<style lang="scss" scoped></style>
